// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressResponse } from './address-response';

// @ts-ignore
import { PersonNameResponse } from './person-name-response';

// @ts-ignore
import { ReferenceDataSummaryResponse } from './reference-data-summary-response';

/** See com.rev360.pms.api.controller.patient.pod.PatientPodPersonInsuranceResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientPodPersonInsuranceResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	effectiveDate!: Date | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	fittingContactLensCoPay!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	generalCoPay!: number | null;

	@GandalfProperty({ designType: String })
	groupNumber!: string | null;

	@GandalfProperty({ designType: AddressResponse })
	insuranceCompanyAddress!: AddressResponse | null;

	@GandalfProperty({ designType: String })
	insuranceCompanyFaxNumber!: string | null;

	@GandalfProperty({ designType: String })
	insuranceCompanyName!: string | null;

	@GandalfProperty({ designType: String })
	insuranceCompanyPhoneNumber!: string | null;

	@GandalfConstantDecorator(constants.InsuranceCompanyStatus)
	@GandalfProperty({ designType: constants.InsuranceCompanyStatus })
	insuranceCompanyStatus!: constants.InsuranceCompanyStatus | null;

	@GandalfProperty({ designType: ReferenceDataSummaryResponse })
	insurancePriority!: ReferenceDataSummaryResponse | null;

	@GandalfProperty({ designType: ReferenceDataSummaryResponse })
	insuranceType!: ReferenceDataSummaryResponse | null;

	@GandalfProperty({ designType: String })
	insuranceWebsite!: string | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	materialCoPay!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	medicalExamCoPay!: number | null;

	@GandalfProperty({ designType: Number })
	personInsuranceId!: number | null;

	@GandalfConstantDecorator(constants.PersonInsuranceStatus)
	@GandalfProperty({ designType: constants.PersonInsuranceStatus })
	personInsuranceStatus!: constants.PersonInsuranceStatus | null;

	@GandalfProperty({ designType: String })
	planName!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	policyHolderDob!: Date | null;

	@GandalfProperty({ designType: PersonNameResponse })
	policyHolderName!: PersonNameResponse | null;

	@GandalfProperty({ designType: String })
	policyNumber!: string | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	routineExamCoPay!: number | null;

}
